import { phoneDigitsOnly } from './phone.js';

/**
 * Build a wa.me URL with a pre-filled message. The phone must already be in
 * E.164 (`+5548999998888`); we strip the "+" before constructing the URL.
 */
export function buildWhatsappUrl(args: { phoneE164: string; message: string }): string {
  const digits = phoneDigitsOnly(args.phoneE164);
  const text = encodeURIComponent(args.message);
  return `https://wa.me/${digits}?text=${text}`;
}
